export default __webpack_public_path__ + "static/media/icon-graph.4e48f0f1.svg";